import { ContentAssociationValidationRules } from "../../../../common/content/types/AssociateContentFormValidationRules";

export const getAssociateFileRecordValidationRules = (): ContentAssociationValidationRules => {
    return {
        isTitleRequired: false,
        areVersionsRequired: false,
        isAirlineRequired: true,
        isEpisodeRequired: false,
        isSeasonRequired: false
    };
};
